module.exports = __webpack_public_path__ + "img/workshop.ffb730ce.png";